import { ComponentPortal } from '@angular/cdk/portal';
import { MatTooltip } from '@angular/material/tooltip';

/*
 * Workaround for an Angular 22 bug (present in @angular/core 22.1.6 through 22.2.0).
 *
 * ViewContainerRef.createComponent() takes the host element namespace from the parent TNode.
 * When the tooltip trigger is the root of an @if block that follows an <svg>, that parent is the
 * @if container node, which is created while the SVG namespace is still active. The
 * <mat-tooltip-component> host is then created as an SVG element and never renders.
 * Visible symptom: the mat-paginator "Last page" tooltip never shows.
 *
 * Creating the portal from the directive's injector instead of its ViewContainerRef makes the
 * overlay create the host element in the HTML namespace. Remove once Angular fixes
 * ViewContainerRef._getHostElementNamespace().
 */
const originalShow = MatTooltip.prototype.show;

MatTooltip.prototype.show = function (this: any, ...args: Parameters<MatTooltip['show']>) {
    if (!this._portal) {
        this._portal = new ComponentPortal(this._tooltipComponent, null, this._injector);
    }
    return originalShow.apply(this, args);
};
